import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";
import { countPendingEmployeesRequest } from "../../api/employee";
import { countPendingFormsRequest } from "../../api/form";

class Dashboard extends Component {

  state = {
    employeesForApprovalCount: null,
    formsForApprovalCount: null,
    error: null
  };

  componentDidMount() {
    if (!this.state.employeesForApprovalCount) {
      this.countEmployees()
    }
    if (!this.state.formsForApprovalCount) {
      this.countForms()
    }
      
  }

  countEmployees(){
    countPendingEmployeesRequest(
      result => this.setState({employeesForApprovalCount: result, error: null}),
      error => this.setState({error: error})
    )
  };

  countForms(){
    countPendingFormsRequest(
      result => this.setState({formsForApprovalCount: result, error: null}),
      error => this.setState({error: error})
    )
  };


  goToEmployeeList = () => {
    this.props.history.push('/approvals/employees/list')
  }

  goToFormList = () => {
    this.props.history.push('/approvals/forms/list')
  }

  render() {

    const {
      employeesForApprovalCount=0,
      formsForApprovalCount=0
    } = this.state;

    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col sm={12}>
              <StatsCard
                bigIcon={<i className="pe-7s-users text-success" />}
                statsText="Employees to approve"
                statsValue={employeesForApprovalCount}
                onClick={this.goToEmployeeList}
              />
            </Col>
            <Col sm={12}>
              <StatsCard
                bigIcon={<i className="pe-7s-note2 text-danger" />}
                statsText="Forms to approve"
                statsValue={formsForApprovalCount}
                onClick={this.goToFormList}
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Dashboard;
